export type MembershipRenewalLabelInput = {
  billingType?: string | null;
  status?: string | null;
  currentPeriodEnd?: Date | string | null;
  cancelAtPeriodEnd?: boolean;
  graceEndsAt?: Date | string | null;
};

function parseDate(value: Date | string | null | undefined): Date | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function formatDate(date: Date) {
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatMembershipRenewalLabel(
  input: MembershipRenewalLabelInput,
): string | null {
  if (input.billingType === 'free') return null;

  const periodEnd = parseDate(input.currentPeriodEnd);
  const graceEndsAt = parseDate(input.graceEndsAt);

  if (input.status === 'past_due') {
    if (graceEndsAt) {
      return `Payment past due · access until ${formatDate(graceEndsAt)}`;
    }
    return 'Payment past due';
  }

  if (input.cancelAtPeriodEnd && periodEnd) {
    return `Access until ${formatDate(periodEnd)}`;
  }

  if (input.status === 'cancelled') {
    return periodEnd ? `Ended ${formatDate(periodEnd)}` : 'Ended';
  }

  if (periodEnd) {
    return `Renews ${formatDate(periodEnd)}`;
  }

  return null;
}

export function formatMembershipStatusLabel(status?: string | null): string {
  if (!status) return 'Unknown';
  if (status === 'past_due') return 'Past due';
  return status.charAt(0).toUpperCase() + status.slice(1);
}
